import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  alignItems: 'flex-start',
};

export const creditUsage: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0, 1),
  color: (p) => p.palette.primary[500],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[200],
  borderRadius: (p) => p.spacing(0.5),
  background: (p) => p.palette.common.white,
};

export const titleWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.25),
};
